<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-top"><span>拆解工单：</span>{{ stinfo.order_code }}</div>
      <div class="info-mid">
        <h1>{{ stinfo.product_sku }}</h1>
        <p>拆解SKU</p>
      </div>
      <div class="info-bottom text-center">
        <dl>
          <dt>拆解日期</dt>
          <dd>{{ stinfo.starttime }}</dd>
        </dl>
        <dl>
          <dt>拆解数量</dt>
          <dd>{{ stinfo.quantity }}</dd>
        </dl>
      </div>
    </div>

    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list chai-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="big-box">
            <div class="st-list-top">
              <div class="t-tit">{{ v.modelkey }}</div>
              <!-- 下箭头 -->
              <div class="arrow"><i class="iconfont icon-arrow"></i></div>
            </div>
            <div class="st-list-main">
              <div class="st-main-detail">
                <p>拆解数量：{{ v.quantity }}</p>
                <p class="litter">异常数量：{{ v.loss }}</p>
              </div>
            </div>
          </div>
          <div class="st-list-bottom-chai">
            <div class="st-main-sec">
              <div class="st-top-sec">
                <div class="t-tit-sec bold">SKU</div>
                <div class="arrow-sec bold">数量</div>
              </div>
              <div class="st-list-sec">
                <dl v-for="(vo, ko) in v.list" :key="ko" :index="ko">
                  <dt>SKU:{{ vo.sku }}</dt>
                  <dd>{{ vo.num }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div class="st-list-box" :class="isdone ? 'pan-107' : 'pan-106'">
        <div class="st-list">
          <div class="st-list-bottom" @click="show_finish_box()">
            <p class="st-opt-btn">拆解完成</p>
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2_finish()">
      <div class="mix-detail-box">
        <h2>拆解完成</h2>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeid: 0,
      finishid: 0,
      isdone: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    edit_st2_finish: function() {
      this.$post(this.$api.stGetChaigongFinish, { id: this.finishid }).then((res) => {
        if (res.code == 200) {
          this.$toast.success("操作成功");
          this.get_st_info();
        } else {
          this.$toastor(res.msg);
        }
      });
    },
    show_finish_box: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetChaigongMain, { id: paramsid }).then((res) => {
        if (res.data.info.haveDone > 0) {
          this.$toast.success("不要重复操作");
        } else {
          this.show = !0;
        }
      });
    },
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetChaigongMain, { id: paramsid }).then((res) => {
        this.stlist = res.data.list;
        this.stinfo = res.data.info;
        this.finishid = res.data.info.id;
        this.isdone = res.data.info.haveDone;
      });
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "拆工" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  padding-top: 10px;
  background: #345;
  margin-bottom: 15px;
}
.info-main .info-top {
  color: #9ab;
  line-height: 2;
  margin: 0 20px;
}
.info-main .info-mid {
  text-align: center;
  color: #fff;
}
.info-main .info-mid h1 {
  line-height: 2.2;
  font-weight: normal;
}
.info-main .info-mid p {
  color: #9ab;
}
.info-main .info-bottom {
  display: flex;
  background: #2f3e50;
  border-top: 1px solid #9ab;
  margin-top: 20px;
  padding: 5px 0;
}
.info-main .info-bottom dl {
  flex: 1;
  line-height: 1.8;
}
.info-main .info-bottom dt {
  color: #9ab;
}
.info-main .info-bottom dd {
  color: #fff;
}

.big-box {
  padding: 15px 15px 5px;
  background: #00baad;
  color: #fff;
}
.litter {
  color: #ffeb3b;
}

.st-list-top .arrow .iconfont {
  font-weight: bolder;
  font-size: 24px;
  line-height: 0.6;
  height: 23px;
  overflow: hidden;
}
.tab-content .chai-list {
  padding: 0;
  padding-bottom: 5px;
}
.tab-content .st-list-top .t-tit {
  border: 0;
  padding: 0;
  font-weight: bold;
}

.st-list-main .st-jian-bottom {
  margin-top: 12px;
  height: 36px;
  background: #00baad;
  border-radius: 5px;
}
.st-list-main .st-jian-bottom .st-opt-btn {
  padding: 3px 20px;
}
.tab-content .st-list-bottom-chai {
  line-height: 2.2;
  padding: 0 15px;
}

.st-top-sec {
  display: flex;
}
.st-list-main .t-tit-sec {
  flex: 1;
}

.st-top-sec .t-tit-sec {
  flex: 1;
}

.st-list-sec dl {
  display: flex;
}
.st-list-sec dt {
  flex: 1;
}

.info-scan {
  margin-top: 2.5em;
  margin-right: 1.5em;
}
.info-scan .van-icon {
  color: #0ba;
  font-size: 50px;
}

.status-00 {
  font-weight: normal;
}
.status-01 {
  color: #43cf7c;
}
.status-02 {
  color: #ff5733;
}
</style>
